import React from 'react';
import PropTypes from 'prop-types';
import { Mutation, Query } from 'react-apollo';

import * as USER_DETAILS from './userDetails.graphql';
import * as RECORD_RESULTS from './recordResults.graphql';

export const Queries = ({ children }) => (
	<Query query={USER_DETAILS}>
		{({ loading, data }) => {
			return (
				<Mutation mutation={RECORD_RESULTS}>
					{recordResults =>
						children({
							loading,
							data,
							recordResults,
						})
					}
				</Mutation>
			);
		}}
	</Query>
);

Queries.propTypes = {
	children: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/shared/screener/queries.js